import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

export class Service {
    static get() {
        return AppContext.getApiClient().get("/roles")
    }
    
    static post(payload) {
        return AppContext.getApiClient().post("/roles", payload)
    }

    static patch(id:string, payload){
        return AppContext.getApiClient().patch(`/roles/${id}`, payload)
    }

    static delete(id: string) {
        return AppContext.getApiClient().delete(`/roles/${id}`)
    }
}


// WEBPACK FOOTER //
// ./src/role/services/service.ts